var PeopleMedia = PeopleMedia || {};
PeopleMedia.CP = PeopleMedia.CP || {};
PeopleMedia.CP.LoginRegistration = (function ($jq) {
    "use strict";

    var Oid = "PeopleMedia.CP.LoginRegistration";
    var _regMgr = null;
    var _profileMgr = null;
    var _loginRegistrationPanelId = "divLoginRegistration";
    var _registrationScriptLoaded = false;
    var _profileScriptLoaded = false;
    var _scriptLoadedComplete = false;

    var _thisObj = null;
    var _onQuestionDisplay = null;
    var _onPanelDisplay = null;
    var _onFacebookImport = null;
    var _onReady = null;
    var SIGNUP_FLOW_TYPE_REGISTRATION_FIRST = 0;
    var SIGNUP_FLOW_TYPE_SINGLE_PROFILE_QUESTIONS_FIRST = 1;
    var SIGNUP_FLOW_TYPE_SINGLE_QUESTIONS_REGISTRATION_FIRST = 2;
    var SIGNUP_FLOW_TYPE_MULTISTEP = 3;
    var SIGNUP_FLOW_TYPE_MULTISTEP_WITH_SUGGEST = 4;

    // API question ids for tracking
    var QUESTION_ID_GENDER_COMBINED = 999;
    var QUESTION_ID_POSTAL_CODE = 1004;
    var QUESTION_ID_EMAIL = 1012;
    var QUESTION_ID_BIRTHDATE = 1013;
    var QUESTION_ID_USERNAME = 1014;
    var QUESTION_ID_PASSWORD = 1015;

    var QUESTION_ID_COUNTRY = 1005;
    var QUESTION_ID_GENDER_MEMBER = 1000;
    var QUESTION_ID_GENDER_SEEKING = 1001;

    var _signupFlowType = SIGNUP_FLOW_TYPE_REGISTRATION_FIRST;

    var _profilePage = null;
    var _defaultProfileOptionListType = 1;
    var _skipInitialGenderQuestion = false;
    var _regMgrOptions = {};
    var _panelValidateInProcess = false;
    var _cssOptions = {};

    var regMgr = function() {
        return _regMgr;
    };

    var profileMgr = function() {
        return _profileMgr;
    };

    var onSuccess = function(onSuccess) {
        try {
            _regMgr.OnRegistrationSuccess(onSuccess);
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "onSuccess" });
        }
    };

    var loginRegistrationPanel = function() {
        return $jq("#" + _loginRegistrationPanelId);
    };

    var onQuestionDisplay = function(onQuestionDisplay) {
        if (arguments.length > 0) {
            _onQuestionDisplay = onQuestionDisplay;
        } else {
            return _onQuestionDisplay;
        }
    };

    var onPanelDisplay = function(onPanelDisplay) {
        if (arguments.length > 0) {
            _onPanelDisplay = onPanelDisplay;
        } else {
            return _onPanelDisplay;
        }
    };

    var onFacebookImport = function(onFacebookImport) {
        if (arguments.length > 0) {
            _onFacebookImport = onFacebookImport;
        } else {
            return _onFacebookImport;
        }
    };

    var onReady = function(onReady) {
        if (arguments.length > 0) {
            _onReady = onReady;
        } else {
            return _onReady;
        }
    };

    var signupFlowType = function(signupFlowType) {
        if (arguments.length > 0) {
            _signupFlowType = signupFlowType;
        } else {
            return _signupFlowType;
        }
    };

    var profilePage = function(profilePage) {
        if (arguments.length > 0) {
            _profilePage = profilePage;
        } else {
            return _profilePage;
        }
    };

    var defaultProfileOptionListType = function(defaultProfileOptionListType) {
        if (arguments.length > 0) {
            _defaultProfileOptionListType = defaultProfileOptionListType;
        } else {
            return _defaultProfileOptionListType;
        }
    };

    var skipInitialGenderQuestion = function(skipInitialGenderQuestion) {
        if (arguments.length > 0) {
            _skipInitialGenderQuestion = skipInitialGenderQuestion;
        } else {
            return _skipInitialGenderQuestion;
        }
    };

    var regMgrOptions = function(regMgrOptions) {
        if (arguments.length > 0) {
            _regMgrOptions = regMgrOptions;
        } else {
            return _regMgrOptions;
        }
    };

    var preventEventDefaultBehavior = function (event) {
        try {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "preventEventDefaultBehavior" });
        }
    };

    var initializeCssOptions = function (cssOptions) {
        _cssOptions = $jq.extend({
                panelShow: "", // css class to include on .panel when displayed
                panelHide: "", // css class to include on .panel to hide
                navBackShow: "", // css class to include on .btnnavback when displayed
                navBackHide: "", // css class to include on .btnnavback to hide
                errorMsgShow: "", // css class to include on .errorMsg when displayed
                errorMsgHide: "", // css class to include on .errorMsg when hidden
                errorSummaryShow: "", // css class to include on .errorSummary when displayed
                errorSummaryHide: "" // css class to include on .errorSummary when hidden
            },
            cssOptions);
        return _cssOptions;
    };

    var initialize = function(signupType) {
        try {
            if (typeof (signupType) !== "undefined" && signupType !== null) {
                signupFlowType(signupType);
            }
            var vcRoot = PeopleMedia.CP.VersionedContentRoot();
            var timeoutValue = 60000;

            var thisObj = PeopleMedia.CP.LoginRegistration;
            PeopleMedia.CP.onReady(function() {
                var startTime3 = new Date().getTime();
                var url3 = vcRoot + "/scripts/registration-v1.3.js";
                jQuery.ajax({
                    url: url3,
                    dataType: "script",
                    success: function() {
                        _registrationScriptLoaded = true;
                        onScriptLoaded.call(thisObj);
                    },
                    error: function(jqXHR, textStatus, errorThrown) {
                        var endTime3 = new Date().getTime();
                        var duration3 = (endTime3 - startTime3);
                        var data = PeopleMedia.CP.convertAjaxErrorToFault(jqXHR, textStatus, errorThrown);
                        if (!data.IsCancelled) {
                            PeopleMedia.CP.logAjax({ oid: Oid, method: "initialize registration", url: url3, duration: duration3, jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
                        }
                    },
                    cache: true,
                    timeout: timeoutValue
                });
                var startTime4 = new Date().getTime();
                var url4 = vcRoot + "/scripts/profile-v1.0.js";
                jQuery.ajax({
                    url: url4,
                    dataType: "script",
                    success: function() {
                        _profileScriptLoaded = true;
                        onScriptLoaded.call(thisObj);
                    },
                    error: function(jqXHR, textStatus, errorThrown) {
                        var endTime4 = new Date().getTime();
                        var duration4 = (endTime4 - startTime4);
                        var data = PeopleMedia.CP.convertAjaxErrorToFault(jqXHR, textStatus, errorThrown);
                        if (!data.IsCancelled) {
                            PeopleMedia.CP.logAjax({ oid: Oid, method: "initialize profile", url: url4, duration: duration4, jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
                        }
                    },
                    cache: true,
                    timeout: timeoutValue
                });
            });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "initialize" });
        }
    };

    var onScriptLoaded = function() {
        try {
            var thisObj = PeopleMedia.CP.LoginRegistration;
            if (!_scriptLoadedComplete && _registrationScriptLoaded && _profileScriptLoaded) {
                _scriptLoadedComplete = true;
                completeInitialization.call(thisObj);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "onScriptLoaded" });
        }
    };

    var completeInitialization = function() {
        try {
            //_regMgr = new PeopleMedia.CP.RegistrationManager();
            //_profileMgr = new PeopleMedia.CP.ProfileManager();

            _thisObj = PeopleMedia.CP.LoginRegistration;
            _regMgr = PeopleMedia.CP.Registration;
            _profileMgr = PeopleMedia.CP.Profile;

            _regMgr.OnQuestionDisplay(function() {
                regMgr_onQuestionDisplay();
            });

            _regMgr.initialize();

            if (typeof (_profileMgr) !== "undefined") {
                _profileMgr.OnQuestionDisplay(function() {
                    profileMgr_onQuestionDisplay();
                });
                if (signupFlowType() === SIGNUP_FLOW_TYPE_REGISTRATION_FIRST) {
                    initializeSignupFlowTypeRegistrationFirst();
                } else if (signupFlowType() === SIGNUP_FLOW_TYPE_SINGLE_QUESTIONS_REGISTRATION_FIRST) {
                    initializeSignupFlowTypeSingleQuestionsRegistrationFirst();
                } else if (signupFlowType() === SIGNUP_FLOW_TYPE_MULTISTEP) {
                    initializeSignupFlowTypeMultiStep();
                } else if (signupFlowType() === SIGNUP_FLOW_TYPE_MULTISTEP_WITH_SUGGEST) {
                    initializeSignupFlowTypeMultiStepWithSuggest();
                } else {
                    initializeSignupFlowTypeSingleProfileQuestionsFirst();
                }
            }

            if (_onReady && Object.prototype.toString.call(_onReady) === '[object Function]') {
                _onReady(_thisObj);
            }
            $jq(PeopleMedia).trigger('PeopleMedia.CP.onAfterCompleteInitialization');
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "completeInitialization" });
        }
    };

    // SIGNUP_FLOW_TYPE_REGISTRATION_FIRST (0)
    var initializeSignupFlowTypeRegistrationFirst = function() {
        try {
            // use question ids from API for tracking
            $jq("body").attr("data-signupflow", signupFlowType());
            $jq("#ddlGenderCombined").attr("data-questionid", QUESTION_ID_GENDER_COMBINED);
            $jq("#ddlGender,#iam").attr("data-questionid", QUESTION_ID_GENDER_MEMBER);
            $jq("#ddlGenderSeek,#seeking").attr("data-questionid", QUESTION_ID_GENDER_SEEKING);
            $jq("#txtPostalCode,input[name='zipcode']").attr("data-questionid", QUESTION_ID_POSTAL_CODE);
            $jq("#txtEmailAddress").attr("data-questionid", QUESTION_ID_EMAIL);
            $jq("#txtBirthDate,#ddlBirthMonth,#ddlBirthDay,#ddlBirthYear").attr("data-questionid", QUESTION_ID_BIRTHDATE);
            $jq("#txtUsername").attr("data-questionid", QUESTION_ID_USERNAME);
            $jq("#txtPassword").attr("data-questionid", QUESTION_ID_PASSWORD);

            // $jq(".registerView").on("fadeInComplete.pmlps", onRegisterView);

            var $defaultForm = $jq(".defaultForm");
            if ($defaultForm.length > 0 && !$defaultForm.hasClass("cp_stateful")) {
                var displayedQuestions = getDisplayedQuestionIds($defaultForm);
                if (displayedQuestions.length > 0) {
                    PeopleMedia.CP.trackRegistrationEventShowRegQuestions(displayedQuestions);
                }
            }

            _regMgr.OnRegistrationFailure(
                function(sender, errors) {
                    _regMgr.standardOnRegistrationFailure(sender, errors);
                });

            if (typeof (_profileMgr) !== 'undefined' && _profileMgr !== null) {
                _regMgr.loadQuestions();
                _regMgr.OnRegistrationSuccess(
                    function(sender, regData) {
                        try {
                            if (typeof (profilePage()) !== 'undefined' && profilePage() !== null) {
                                if (PeopleMedia.CP.gotoLpsPage) {
                                    PeopleMedia.CP.gotoLpsPage(profilePage());
                                } else {
                                    PeopleMedia.CP.gotoSite("/v3/lps?cpp=" + profilePage());
                                }
                            } else if (_profileMgr.ProfilePanel().length > 0) {
                                _profileMgr.loadQuestions();
                                loginRegistrationPanel().fadeOut('fast',
                                    function () {
                                        _profileMgr.ProfilePanel().fadeIn('slow',
                                            function () {
                                                if (this.style.removeAttribute) {
                                                    this.style.removeAttribute('filter');
                                                }
                                            });
                                    });
                                PeopleMedia.CP.Messaging.reset();
                            } else {
                                _regMgr.standardOnRegistrationSuccess(sender, regData);
                            }
                            return;
                        } catch (ex) {
                            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "initializeSignupFlowTypeRegistrationFirst OnRegistrationSuccess callback" });
                        }
                    });
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "initializeSignupFlowTypeRegistrationFirst" });
        }
    };

    // SIGNUP_FLOW_TYPE_SINGLE_PROFILE_QUESTIONS_FIRST (1)
    var initializeSignupFlowTypeSingleProfileQuestionsFirst = function() {
        try {
            // use question ids from API for tracking
            $jq("body").attr("data-signupflow", signupFlowType());
            $jq("#ddlGenderCombined").attr("data-questionid", QUESTION_ID_GENDER_COMBINED);
            $jq("#ddlGender").attr("data-questionid", QUESTION_ID_GENDER_MEMBER);
            $jq("#ddlGenderSeek").attr("data-questionid", QUESTION_ID_GENDER_SEEKING);
            $jq("#txtPostalCode").attr("data-questionid", QUESTION_ID_POSTAL_CODE);
            $jq("#txtEmailAddress").attr("data-questionid", QUESTION_ID_EMAIL);
            $jq("#txtBirthDate,#ddlBirthMonth,#ddlBirthDay,#ddlBirthYear").attr("data-questionid", QUESTION_ID_BIRTHDATE);
            $jq("#txtUsername").attr("data-questionid", QUESTION_ID_USERNAME);
            $jq("#txtPassword").attr("data-questionid", QUESTION_ID_PASSWORD);
            $jq("#ddlCountry,#ddlCountryContainer").attr("data-questionid", QUESTION_ID_COUNTRY);

            // not starting with registration questions, so hide the registration panel and show the profile panel
            loginRegistrationPanel().hide();
            _profileMgr.ProfilePanel().show();

            // use list boxes rather than dropdowns for profile questions
            _profileMgr.DefaultOptionListType(defaultProfileOptionListType());

            // don't include 'choose' in the dropdown options
            _profileMgr.AddChooseOptionToResponses(false);

            // start with gender question (it's a registration question so we have to handle it as a special case to show it first)
            if (typeof (PeopleMedia.CP.GenderSeekEnabled()) !== 'undefined' &&
                PeopleMedia.CP.GenderSeekEnabled() !== null &&
                PeopleMedia.CP.GenderSeekEnabled()) {
                _profileMgr.InitialQuestions([
                    {
                        "QuestionID": QUESTION_ID_GENDER_COMBINED,
                        "QuestionText": "Gender",
                        Responses: [
                            { "ResponseID": 12, "ResponseText": "Man seeking women" },
                            { "ResponseID": 21, "ResponseText": "Woman seeking men" },
                            { "ResponseID": 11, "ResponseText": "Man seeking men" },
                            { "ResponseID": 22, "ResponseText": "Woman seeking women" }
                        ]
                    }
                ]);
                _profileMgr.addQuestionTextOverride(QUESTION_ID_GENDER_COMBINED, "You are:");
            } else {
                _profileMgr.InitialQuestions([
                    {
                        "QuestionID": 13,
                        "QuestionText": "Gender",
                        Responses: [
                            { "ResponseID": 1, "ResponseText": "Male" },
                            { "ResponseID": 2, "ResponseText": "Female" }
                        ]
                    }
                ]);
                _profileMgr.addQuestionTextOverride(13, "You are:");
            }

            // override question & response text
            _profileMgr.addQuestionTextOverride(1, "What color is your hair?");
            _profileMgr.addQuestionTextOverride(2, "What color are your eyes?");
            _profileMgr.addQuestionTextOverride(19, "How tall are you?");
            _profileMgr.addQuestionTextOverride(101, "What is your ethnicity?");
            _profileMgr.addQuestionTextOverride(4, "What is your body type?");
            _profileMgr.addQuestionTextOverride(100, "How would you describe your looks?");
            _profileMgr.addQuestionTextOverride(5, "What is your marital status?");
            _profileMgr.addQuestionTextOverride(16, "How many children do you have?");
            _profileMgr.addQuestionTextOverride(17, "Number of children living with me:");
            _profileMgr.addQuestionTextOverride(98, "Do you smoke?");

            _profileMgr.addResponseTextOverride(1, 7, "What hair?");

            // exclude height 4'0" - 4'4"
            for (var i = (4 * 12); i < (4 * 12 + 5); ++i) {
                _profileMgr.excludeResponse(19, i.toString());
            }

            // exclude # children, 10+
            _profileMgr.excludeResponse(16, "10");

            // exclude # children living with me, 10+
            _profileMgr.excludeResponse(17, "10");

            // set the profile questions panel count for the profile questions (1 panel per question)
            _profileMgr.OnQuestionsLoaded(function(sender, questions, loadQuestionOptions) {
                _profileMgr.PanelCount(questions.length);
                if (typeof loadQuestionOptions !== 'undefined' && loadQuestionOptions !== null && loadQuestionOptions.loadOnly !== true) {
                    // showPanel was shown as part of profile loadQuestions, so fire the question display
                    var displayInfo = getCurrentQuestionDisplayInfo("profile");
                    fireOnQuestionDisplay(displayInfo);
                }
            });

            var onQuestionDisplay = _onQuestionDisplay; // don't fire this event until profile questions loaded
            _onQuestionDisplay = null;

            var regMgrOnQuestionDisplay = _regMgr.OnQuestionDisplay();
            _regMgr.OnQuestionDisplay(null);

            // load the registration questsion so we know how many there are for the percent complete
            _regMgr.loadQuestions({ loadOnly: true });
            _regMgr.PanelCount(_regMgr.Questions().length);

            _onQuestionDisplay = onQuestionDisplay;
            _regMgr.OnQuestionDisplay(regMgrOnQuestionDisplay);

            _regMgr.OnRegistrationFailure(function(sender, errors) {
                var errorResult = convertErrorArrayToErrorObject(errors);
                if (errorResult.duplicateEmail) {
                    errors = [
                        {
                            Field: _regMgr.EmailAddressFieldname(),
                            Text: 'Sorry, an account has already been registered to that email address. <a href="' +
                                PeopleMedia.CP.getSiteUrl('/v3/forgotpassword') +
                                '" target="_blank">Click here</a> to go to &quot;<a href="' +
                                PeopleMedia.CP.getSiteUrl('/v3/forgotpassword') +
                                '" target="_blank">Forgot Password</a>&quot; and the username and password will be emailed to you.',
                            IsHtml: true
                        }
                    ];
                    _regMgr.CurrentPanelNumber(_regMgr.PanelCount());
                    _regMgr.showPanel(_regMgr.CurrentPanelNumber());
                    _regMgr.standardOnRegistrationFailure(sender, errors);
                } else {
                    _regMgr.standardOnRegistrationFailure(sender, errors);
                }
            });

            // load and display the questions
            _profileMgr.loadQuestions();

            // handle the pre-submit event to instead load the registration questions
            _profileMgr.OnQuestionsPreSubmit(function (sender, questions) {
                if (!PeopleMedia.CP.Member || !PeopleMedia.CP.Member.PublicMemberId) {
                    // combined gender is presented during the profile question stage, so we must inject it into the registration stage
                    var profileGenderCombinedResponseFieldname = _profileMgr.ResponseFieldnamePrefix() + QUESTION_ID_GENDER_COMBINED.toString();
                    if ($jq('#' + profileGenderCombinedResponseFieldname).length > 0) {
                        if ($jq('#' + _regMgr.GenderCombinedFieldname()).length > 0) {
                            $jq('#' + _regMgr.GenderCombinedFieldname())
                                .val($jq('#' + profileGenderCombinedResponseFieldname).val());
                        } else {
                            var responseGenderCombinedElementHtml = "<select id='" +
                                _regMgr.GenderCombinedFieldname() + "' name='" +
                                _regMgr.GenderCombinedFieldname() + "' data-questionid='" + QUESTION_ID_GENDER_COMBINED.toString() + "' style='display:none;'>";
                            responseGenderCombinedElementHtml += "<option value='12'>Man seeking women</option>";
                            responseGenderCombinedElementHtml += "<option value='21'>Woman seeking men</option>";
                            responseGenderCombinedElementHtml += "<option value='11'>Man seeking men</option>";
                            responseGenderCombinedElementHtml += "<option value='22'>Woman seeking women</option>";
                            responseGenderCombinedElementHtml += "</select>";
                            responseGenderCombinedElementHtml += "<input type='hidden' id='" +
                                _regMgr.GenderFieldname() +
                                "' name='" +
                                _regMgr.GenderFieldname() +
                                "' data-questionid='" + QUESTION_ID_GENDER_COMBINED.toString() + "' />";
                            responseGenderCombinedElementHtml += "<input type='hidden' id='" +
                                _regMgr.GenderSeekFieldname() +
                                "' name='" +
                                _regMgr.GenderSeekFieldname() +
                                "' data-questionid='" + QUESTION_ID_GENDER_COMBINED.toString() + "' />";
                            _regMgr.RegistrationPanel().append(responseGenderCombinedElementHtml);
                            $jq('#' + _regMgr.GenderCombinedFieldname()).val($jq('#' + profileGenderCombinedResponseFieldname).val());
                        }

                        var profileGenderCombinedResponseFieldValue = $jq('#' + profileGenderCombinedResponseFieldname).val();
                        if ($jq('#' + _regMgr.GenderFieldname()).length > 0 && profileGenderCombinedResponseFieldValue.length === 2) {
                            $jq('#' + _regMgr.GenderFieldname()).val(profileGenderCombinedResponseFieldValue.substr(0, 1));
                        }
                        if ($jq('#' + _regMgr.GenderSeekFieldname()).length > 0 && profileGenderCombinedResponseFieldValue.length === 2) {
                            $jq('#' + _regMgr.GenderSeekFieldname()).val(profileGenderCombinedResponseFieldValue.substr(1, 1));
                        }
                    } else {
                        // gender is presented during the profile question stage, so we must inject it into the registration stage
                        var profileGenderResponseFieldname = _profileMgr.ResponseFieldnamePrefix() + "13";
                        if ($jq('#' + profileGenderResponseFieldname).length > 0) {
                            if ($jq('#' + _regMgr.GenderFieldname()).length > 0) {
                                $jq('#' + _regMgr.GenderFieldname()).val($jq('#' + profileGenderResponseFieldname).val());
                            } else {
                                var responseElementHtml = "<select id='" +
                                    _regMgr.GenderFieldname() +
                                    "' name='" +
                                    _regMgr.GenderFieldname() +
                                    "' style='display:none;'>";
                                responseElementHtml += "<option value='1'>Male</option>";
                                responseElementHtml += "<option value='2'>Female</option>";
                                responseElementHtml += "</select>";
                                _regMgr.RegistrationPanel().append(responseElementHtml);
                                $jq('#' + _regMgr.GenderFieldname()).val($jq('#' + profileGenderResponseFieldname).val());
                            }
                        }
                    }

                    _profileMgr.ProfilePanel().hide();
                    loginRegistrationPanel().show();
                    _regMgr.loadQuestions();
                    _regMgr.RegistrationPanel().show();
                    return false;
                } else {
                    return true;
                }
            });

            // when the registration is successful, submit the profile questions
            _regMgr.OnRegistrationSuccess(function (sender, regData) {
                //if (regData.MemberId) {
                //    PeopleMedia.CP.MemberID(regData.MemberId);
                //}
                //if (regData.EncMemberId) {
                //    PeopleMedia.CP.EncodedMemberID(regData.EncMemberId);
                //}
                //PeopleMedia.CP.MemberID(regData.Identifier);
                //PeopleMedia.CP.EncodedMemberID(regData.EncodedIdentifier);
                _profileMgr.OnQuestionsSubmitted(function() {
                    try {
                        if (typeof (_profileMgr.NextPage()) === 'undefined' || _profileMgr.NextPage() === null || _profileMgr.NextPage().length === 0) {
                            PeopleMedia.CP.gotoCPPage("/site/landingpages/shared/essay-02.html");
                        } else {
                            PeopleMedia.CP.gotoCPPage(_profileMgr.NextPage());
                        }
                        return;
                    } catch (ex) {
                        PeopleMedia.CP.handleException(ex, { oid: Oid, method: "initializeSignupFlowTypeRegistrationFirst OnRegistrationSuccess callback" });
                    }
                });
                _profileMgr.submit();
            });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "initializeSignupFlowTypeSingleProfileQuestionsFirst" });
        }
    };

    // SIGNUP_FLOW_TYPE_SINGLE_QUESTIONS_REGISTRATION_FIRST (2)
    var initializeSignupFlowTypeSingleQuestionsRegistrationFirst = function() {
        try {
            var thisObj = PeopleMedia.CP.LoginRegistration;
            var currentRegMgrOptions = _regMgrOptions;
            if (typeof currentRegMgrOptions !== "object" || currentRegMgrOptions === null) {
                currentRegMgrOptions({});
            }
            var regMgrOptions = { insertGender: true, combinedGender: true, loadOnly: true };
            if (typeof currentRegMgrOptions.questionOrder !== 'undefined') {
                regMgrOptions.questionOrder = currentRegMgrOptions.questionOrder;
            }
            if (typeof currentRegMgrOptions.questionDefaultValues !== 'undefined') {
                regMgrOptions.questionDefaultValues = currentRegMgrOptions.questionDefaultValues;
            }
            if (typeof currentRegMgrOptions.splitUsernamePassword !== 'undefined') {
                regMgrOptions.splitUsernamePassword = currentRegMgrOptions.splitUsernamePassword;
            }
            if (typeof currentRegMgrOptions.splitGenderSeeking !== 'undefined') {
                regMgrOptions.splitGenderSeeking = currentRegMgrOptions.splitGenderSeeking;
                regMgrOptions.combinedGender = false;
            }
            if (typeof currentRegMgrOptions.assignCountryCodeFromPostalCode !== 'undefined') {
                regMgrOptions.assignCountryCodeFromPostalCode = currentRegMgrOptions.assignCountryCodeFromPostalCode;
            }
            if (typeof currentRegMgrOptions.customLocatorIcon !== 'undefined') {
                regMgrOptions.customLocatorIcon = currentRegMgrOptions.customLocatorIcon;
            }

            // use question ids from API for tracking
            $jq("body").attr("data-signupflow", signupFlowType());
            $jq("#ddlGenderCombined").attr("data-questionid", QUESTION_ID_GENDER_COMBINED);
            $jq("#ddlGender").attr("data-questionid", QUESTION_ID_GENDER_MEMBER);
            $jq("#ddlGenderSeek").attr("data-questionid", QUESTION_ID_GENDER_SEEKING);

            $jq("#ddlCountry").attr("data-questionid", QUESTION_ID_COUNTRY);
            $jq("#txtPostalCode").attr("data-questionid", QUESTION_ID_POSTAL_CODE);
            $jq("#txtEmailAddress").attr("data-questionid", QUESTION_ID_EMAIL);
            $jq("#txtBirthDate,#ddlBirthMonth,#ddlBirthDay,#ddlBirthYear").attr("data-questionid", QUESTION_ID_BIRTHDATE);
            $jq("#txtUsername,#txtRegistrationNewUsername").attr("data-questionid", QUESTION_ID_USERNAME);
            $jq("#txtPassword").attr("data-questionid", QUESTION_ID_PASSWORD);

            // initialize locate me
            $jq(".locate, .locate-hidden, .locate-image").on("click",
                function (event) {
                    preventEventDefaultBehavior(event);
                    var locator = event.target;
                    if (!regMgrOptions.customLocatorIcon) {
                        var animation = window.setInterval(function() {
                                $jq(locator).animate({ rotate: "+=15deg" }, 0);
                            },
                            50);
                    }
                    _regMgr.locateMe(
                        function(result) {
                            if (!regMgrOptions.customLocatorIcon) {
                                window.clearInterval(animation);
                                $jq(locator).css("transform", "rotate(0deg)");
                            }
                            $jq("#txtPostalCode").val(result.PostalCode);
                        },
                        function(errors) {
                            var locateErrors = [
                                {
                                    Field: 'txtPostalCode',
                                    Text:
                                        'We were unable to locate you. Please make sure you have a data connection and try again.'
                                }
                            ];
                            if (!regMgrOptions.customLocatorIcon) {
                                window.clearInterval(animation);
                                $jq(locator).css("transform", "rotate(0deg)");
                            }
                            PeopleMedia.CP.Messaging.show(locateErrors);
                        });
                });

            $jq(window).on("resize", function() {
                _regMgr.searchPositionLocators.call(thisObj);
            });

            // show the registration panel and hide the profile panels
            loginRegistrationPanel().show();
            _profileMgr.ProfilePanel().hide();

            // use list boxes rather than dropdowns for profile questions
            _profileMgr.DefaultOptionListType(defaultProfileOptionListType());

            // don't include 'choose' in the dropdown options
            _profileMgr.AddChooseOptionToResponses(false);

            // override question & response text
            _profileMgr.addQuestionTextOverride(1, "What color is your hair?");
            _profileMgr.addQuestionTextOverride(2, "What color are your eyes?");
            _profileMgr.addQuestionTextOverride(19, "How tall are you?");
            _profileMgr.addQuestionTextOverride(101, "What is your ethnicity?");
            _profileMgr.addQuestionTextOverride(4, "What is your body type?");
            _profileMgr.addQuestionTextOverride(100, "How would you describe your looks?");
            _profileMgr.addQuestionTextOverride(5, "What is your marital status?");
            _profileMgr.addQuestionTextOverride(16, "How many children do you have?");
            _profileMgr.addQuestionTextOverride(17, "Number of children living with me:");
            _profileMgr.addQuestionTextOverride(98, "Do you smoke?");

            _profileMgr.addResponseTextOverride(1, 7, "What hair?");

            // exclude height 4'0" - 4'4"
            for (var i = (4 * 12); i < (4 * 12 + 5); ++i) {
                _profileMgr.excludeResponse(19, i.toString());
            }

            // exclude # children, 10+
            _profileMgr.excludeResponse(16, "10");

            // exclude # children living with me, 10+
            _profileMgr.excludeResponse(17, "10");

            // set the profile questions panel count for the profile questions (1 panel per question)
            _profileMgr.OnQuestionsLoaded(function(sender, questions, loadQuestionOptions) {
                _profileMgr.PanelCount(questions.length);

                // set panels after profile questions load is complete
                _profileMgr.ProfilePanel().hide();
                loginRegistrationPanel().show();

                _regMgr.showPanel(1, "initializeSignupFlow");
                _regMgr.RegistrationPanel().show();
                if (skipInitialGenderQuestion()) {
                    showNextPanel();
                }
            });

            // load the registration questions first so we know how many there are for the percent complete
            _regMgr.loadQuestions(regMgrOptions);
            _regMgr.PanelCount(_regMgr.Questions().length);

            _profileMgr.loadQuestions({ loadOnly: true, optionalQuestions: true });

            _profileMgr.OnQuestionsSubmitted(function() {
                try {
                    if (typeof (_profileMgr.NextPage()) === 'undefined' || _profileMgr.NextPage() === null || _profileMgr.NextPage().length === 0) {
                        PeopleMedia.CP.gotoCPPage("/site/landingpages/shared/essay-02.html");
                    } else {
                        PeopleMedia.CP.gotoCPPage(_profileMgr.NextPage());
                    }
                    return;
                } catch (ex) {
                    PeopleMedia.CP.handleException(ex, { oid: Oid, method: "initializeSignupFlowTypeRegistrationFirst OnRegistrationSuccess callback" });
                }

            });

            _regMgr.OnRegistrationFailure(function(sender, errors) {
                var errorResult = convertErrorArrayToErrorObject(errors);
                if (errorResult.duplicateEmail) {
                    errors = [
                        {
                            Field: _regMgr.EmailAddressFieldname(),
                            Text: 'Sorry, an account has already been registered to that email address. <a href="' +
                                PeopleMedia.CP.getSiteUrl('/v3/forgotpassword') +
                                '" target="_blank">Click here</a> to go to &quot;<a href="' +
                                PeopleMedia.CP.getSiteUrl('/v3/forgotpassword') +
                                '" target="_blank">Forgot Password</a>&quot; and the username and password will be emailed to you.',
                            IsHtml: true
                        }
                    ];
                    _regMgr.CurrentPanelNumber(_regMgr.PanelCount());
                    _regMgr.showPanel(_regMgr.CurrentPanelNumber());
                    _regMgr.standardOnRegistrationFailure(sender, errors);
                } else {
                    _regMgr.standardOnRegistrationFailure(sender, errors);
                }
            });

            // when the registration is successful, proceed with the profile questions
            _regMgr.OnRegistrationSuccess(function(sender, regData) {
                try {
                    if (typeof (profilePage()) !== 'undefined' && profilePage() !== null) {
                        if (PeopleMedia.CP.gotoLpsPage) {
                            PeopleMedia.CP.gotoLpsPage(profilePage());
                        } else {
                            PeopleMedia.CP.gotoSite("/v3/lps?cpp=" + profilePage());
                        }
                    } else if (_profileMgr.ProfilePanel().length > 0) {
                        _profileMgr.showPanel(1, "OnRegistrationSuccess authenticate");
                        // handle the pre-submit event to instead load the registration questions
                        _profileMgr.OnQuestionsPreSubmit(function(sender, questions) {
                            if (_profileMgr.ProfilePanel().length > 0 &&
                                _profileMgr.CurrentPanelNumber() >=
                                _profileMgr.PanelCount()) {
                                _profileMgr.OnQuestionsPreSubmit(null);
                                _profileMgr.submit();
                                return false;
                            }
                            return true;
                        });

                        loginRegistrationPanel().fadeOut('fast',
                            function() {
                                _profileMgr.ProfilePanel().fadeIn('slow',
                                    function() {
                                        if (this.style.removeAttribute) {
                                            this.style.removeAttribute('filter');
                                        }
                                        fireOnQuestionDisplay(
                                            getCurrentQuestionDisplayInfo("profile"));
                                    });
                            });
                        PeopleMedia.CP.Messaging.reset();
                    }
                    return;
                } catch (ex) {
                    PeopleMedia.CP.handleException(ex, { oid: Oid, method: "initializeSignupFlowTypeSingleQuestionsRegistrationFirst OnRegistrationSuccess callback" });
                }
            });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "initializeSignupFlowTypeSingleProfileQuestionsFirst" });
        }
    };

    var showNextPanel = function(e) {
        try {
            preventEventDefaultBehavior(e);
            if ($jq("#" + _profileMgr.ProfilePanelId() + ":visible").length > 0) {
                _profileMgr.showNextPanel();
            } else if ($jq("#" + (_regMgr).RegistrationPanelId() + ":visible").length > 0) {
                _regMgr.showNextPanel();
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "showNextPanel" });
        }
    };

    var showPreviousPanel = function(e) {
        try {
            preventEventDefaultBehavior(e);
            if ($jq("#" + _profileMgr.ProfilePanelId() + ":visible").length > 0) {
                _profileMgr.showPreviousPanel();
            } else if ($jq("#" + _regMgr.RegistrationPanelId() + ":visible").length > 0) {
                if (_regMgr.CurrentPanelNumber() === 1) {
                    loginRegistrationPanel().hide();
                    _profileMgr.ProfilePanel().show();
                    // call showPanel to track currently displayed question
                    _profileMgr.showPanel(_profileMgr.CurrentPanelNumber(), "loginRegistration showPreviousPanel");
                    profileMgr_onQuestionDisplay();
                } else {
                    _regMgr.showPreviousPanel();
                }
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "showPreviousPanel" });
        }
    };

    var showZipPostalCodeCityStatePanel = function(countryCode) {
        if (typeof (countryCode) !== 'undefined') {
            $jq('#' + _regMgr.CountryCodeFieldname()).val(countryCode);
        }
        _regMgr.updateZipPostalCodeLabel();
        _regMgr.showZipPostalCodeCityState();
        showNextPanel();
    };

    var getCurrentQuestionDisplayInfo = function(questionType) {
        var displayInfo = {
            questionType: questionType,
            question: null,
            questionID: null,
            questionValue: null,
            panelNumber: null,
            panelCount: null,
            totalPanelNumber: null,
            totalPanelCount: null,
            percentComplete: null,
            questionContainerId: null
        };
        try {
            if (questionType === "profile" && typeof _profileMgr !== 'undefined' && _profileMgr !== null) {
                displayInfo.question = _profileMgr.getCurrentQuestion();
                displayInfo.questionID = _profileMgr.getCurrentQuestionID();
                displayInfo.questionValue = _profileMgr.getCurrentQuestionValue();
                displayInfo.panelNumber = _profileMgr.CurrentPanelNumber();
                displayInfo.panelCount = _profileMgr.PanelCount();
                displayInfo.questionContainerId =
                    _profileMgr.QuestionContainerId() + '_' + displayInfo.panelNumber.toString();
            } else if (questionType === "registration" &&
                typeof _regMgr !== 'undefined' &&
                _regMgr !== null) {
                displayInfo.question = _regMgr.getCurrentQuestion();
                displayInfo.questionID = _regMgr.getCurrentQuestionID();
                displayInfo.questionValue = _regMgr.getCurrentQuestionValue();
                displayInfo.panelNumber = _regMgr.CurrentPanelNumber();
                displayInfo.panelCount = _regMgr.PanelCount();
                if (displayInfo.panelNumber > 0) {
                    displayInfo.questionContainerId = 'divRegistrationQuestions_' + displayInfo.panelNumber.toString();
                }
            }
            displayInfo.totalPanelNumber = totalPanelNumber(questionType);
            displayInfo.totalPanelCount = totalPanelCount();
            displayInfo.percentComplete = percentComplete(questionType);
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getCurrentQuestionDisplayInfo", questionType: questionType });
        }
        return displayInfo;
    };

    var profileMgr_onQuestionDisplay = function() {
        try {
            if (_profileMgr.CurrentPanelNumber() === 1) {
                $jq('.divProfilePrevious').hide();
            } else {
                $jq('.divProfilePrevious').show();
            }
            var val = _profileMgr.getCurrentQuestionValue();
            if (typeof (val) !== "undefined" && val !== null && val.length > 0) {
                $jq('.divProfileNext').show();
            } else {
                $jq('.divProfileNext').hide();
            }

            fireOnQuestionDisplay(getCurrentQuestionDisplayInfo("profile"));
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "profileMgr_onQuestionDisplay" });
        }
    };

    var regMgr_onQuestionDisplay = function() {
        try {
            if (signupFlowType() === SIGNUP_FLOW_TYPE_SINGLE_QUESTIONS_REGISTRATION_FIRST) {
                if (_regMgr.CurrentPanelNumber() === 1) {
                    $jq('.divProfilePrevious').hide();
                } else {
                    $jq('.divProfilePrevious').show();
                }
            } else {
                $jq('.divProfilePrevious').show();
            }
            _regMgr.validateCurrentQuestion(function(errors) {
                if (typeof (errors) === 'undefined' || errors === null || errors.length <= 0) {
                        $jq('.divProfileNext').show();
                    } else {
                        $jq('.divProfileNext').hide();
                    }
                },
                function(errors) {
                    if (typeof (errors) === 'undefined' || errors === null || errors.length <= 0) {
                        $jq('.divProfileNext').show();
                    } else {
                        $jq('.divProfileNext').hide();
                    }
                });
            fireOnQuestionDisplay(getCurrentQuestionDisplayInfo("registration"));
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "regMgr_onQuestionDisplay" });
        }
    };

    var fireOnQuestionDisplay = function(question) {
        try {
            var thisObj = PeopleMedia.CP.LoginRegistration;
            if (typeof(_onQuestionDisplay) !== 'undefined' && _onQuestionDisplay !== null) {
                // Some callers are using lines like "this._regMgr.GenderCombinedSelf();" in the templates 
                // which throws a this._regMgr is not defined if we don't force the context to be PeopleMedia.CP.LoginRegistration
                _onQuestionDisplay.call(thisObj, question);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "fireOnQuestionDisplay", question: question });
        }
    };

    var fireOnPanelDisplay = function(panel) {
        try {
            var thisObj = PeopleMedia.CP.LoginRegistration;
            if (typeof (_onPanelDisplay) !== "undefined" && _onPanelDisplay !== null) {
                // Some callers are using lines like "this._regMgr.GenderCombinedSelf();" in the templates 
                // which throws a this._regMgr is not defined if we don't force the context to be PeopleMedia.CP.LoginRegistration
                _onPanelDisplay.call(thisObj, panel);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "fireOnPanelDisplay", panel: panel });
        }
    };

    var percentComplete = function(questionType) {
        try {
            var panelNumber = totalPanelNumber(questionType) || 0;
            var totalPanels = totalPanelCount() || 0;
            if (totalPanels > 0) {
                return (100.0 * panelNumber) / totalPanels;
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "percentComplete" });
        }
        return 0;
    };

    var totalPanelNumber = function(questionType) {
        try {
            if (signupFlowType() === SIGNUP_FLOW_TYPE_SINGLE_PROFILE_QUESTIONS_FIRST) {
                if ((questionType === "profile" && $jq("#" + _profileMgr.ProfilePanelId()).length > 0) ||
                    $jq("#" + _profileMgr.ProfilePanelId() + ":visible").length > 0) {
                    return _profileMgr.CurrentPanelNumber();
                } else {
                    return (_profileMgr.PanelCount() + _regMgr.CurrentPanelNumber());
                }
            } else if (signupFlowType() === SIGNUP_FLOW_TYPE_SINGLE_QUESTIONS_REGISTRATION_FIRST) {
                if ((questionType === "profile" && $jq("#" + _profileMgr.ProfilePanelId()).length > 0) ||
                    $jq("#" + _profileMgr.ProfilePanelId() + ":visible").length > 0) {
                    return (_profileMgr.CurrentPanelNumber() + _regMgr.PanelCount());
                } else {
                    return _regMgr.CurrentPanelNumber();
                }
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "totalPanelNumber" });
        }
        return 0;
    };

    var totalPanelCount = function() {
        try {
            if (signupFlowType() === SIGNUP_FLOW_TYPE_SINGLE_PROFILE_QUESTIONS_FIRST ||
                signupFlowType() === SIGNUP_FLOW_TYPE_SINGLE_QUESTIONS_REGISTRATION_FIRST) {
                return (_profileMgr.PanelCount() + _regMgr.PanelCount());
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "totalPanelCount" });
        }
        return 0;
    };

    var convertErrorArrayToErrorObject = function(errors) {
        var result = {
            duplicateEmail: false
        };
        try {
            var currentSiteId = PeopleMedia.CP.SiteID();
            if (errors) {
                for (var i = 0; i < errors.length; i++) {
                    var errorCode = errors[i].Code;
                    var errorText = (errors[i].Text || "").toLowerCase();
                    if (errorText.indexOf("{") > -1) {
                        errorText = "An error has occurred.";
                    }
                    if (errorCode === "DuplicateEmailAddress" ||
                        errorText.indexOf("email address provided is already registered") > -1) {
                        result.duplicateEmail = true;
                    }
                }
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "convertErrorArrayToErrorObject" });
        }
        return result;
    };

    // SIGNUP_FLOW_TYPE_MULTISTEP (3)
    var initializeSignupFlowTypeMultiStep = function() {
        try {
            var thisObj = PeopleMedia.CP.LoginRegistration;
            var currentRegMgrOptions = _regMgrOptions;

            if (typeof currentRegMgrOptions !== "object" || currentRegMgrOptions === null) {
                currentRegMgrOptions({});
            }
            var regMgrOptions = { insertGender: true, combinedGender: true, loadOnly: true };
            if (typeof currentRegMgrOptions.questionOrder !== 'undefined') {
                regMgrOptions.questionOrder = currentRegMgrOptions.questionOrder;
            }
            if (typeof currentRegMgrOptions.questionDefaultValues !== 'undefined') {
                regMgrOptions.questionDefaultValues = currentRegMgrOptions.questionDefaultValues;
            }
            if (typeof currentRegMgrOptions.splitUsernamePassword !== 'undefined') {
                regMgrOptions.splitUsernamePassword = currentRegMgrOptions.splitUsernamePassword;
            }
            if (typeof currentRegMgrOptions.splitGenderSeeking !== 'undefined') {
                regMgrOptions.splitGenderSeeking = currentRegMgrOptions.splitGenderSeeking;
                regMgrOptions.combinedGender = false;
            }
            if (typeof currentRegMgrOptions.assignCountryCodeFromPostalCode !== 'undefined') {
                regMgrOptions.assignCountryCodeFromPostalCode = currentRegMgrOptions.assignCountryCodeFromPostalCode;
            }
            if (typeof currentRegMgrOptions.customLocatorIcon !== 'undefined') {
                regMgrOptions.customLocatorIcon = currentRegMgrOptions.customLocatorIcon;
            }
            regMgrOptions.cssOptions = initializeCssOptions((typeof currentRegMgrOptions.cssOptions !== 'undefined')
                ? currentRegMgrOptions.cssOptions
                : {});

            // use question ids from API for tracking
            $jq("body").attr("data-signupflow", signupFlowType());
            $jq("select[name='ddlGenderCombined']").attr("data-questionid", QUESTION_ID_GENDER_COMBINED);
            $jq("input[name='txtPostalCode']").attr("data-questionid", QUESTION_ID_POSTAL_CODE);
            $jq("input[name='txtEmailAddress']").attr("data-questionid", QUESTION_ID_EMAIL);
            $jq("input[name='txtBirthDate']").attr("data-questionid", QUESTION_ID_BIRTHDATE);
            $jq("input[name='txtUsername'],input[name='txtUsernameOther']").attr("data-questionid", QUESTION_ID_USERNAME);
            $jq("input[name='txtPassword']").attr("data-questionid", QUESTION_ID_PASSWORD);

            // searchPageInit
            if (!PeopleMedia.CP.GenderSeekEnabled()) {
                $jq("#ddlGenderCombined").find("option[value='11'], option[value='22']").remove();
            }
            if ((PeopleMedia.CP.DefaultGenderID() === 1 || PeopleMedia.CP.DefaultGenderID() === 2) &&
                (PeopleMedia.CP.DefaultGenderSeekID() === 1 || PeopleMedia.CP.DefaultGenderSeekID() === 2) &&
                (PeopleMedia.CP.GenderSeekEnabled() || PeopleMedia.CP.DefaultGenderID() !== PeopleMedia.CP.DefaultGenderSeekID())
                ) {
                $jq('#ddlGenderCombined').val(PeopleMedia.CP.DefaultGenderID().toString() + PeopleMedia.CP.DefaultGenderSeekID().toString());
            }

            // event handlers
            $jq(".locate, .locate-hidden, .locate-image").on("click",
                function (event) {
                    preventEventDefaultBehavior(event);
                    var locator = event.target;
                    if (!regMgrOptions.customLocatorIcon) {
                        var animation = window.setInterval(function() {
                                $jq(locator).animate({ rotate: "+=15deg" }, 0);
                            },
                            50);
                    }
                    _regMgr.locateMe(
                        function(result) {
                            if (!regMgrOptions.customLocatorIcon) {
                                window.clearInterval(animation);
                                $jq(locator).css("transform", "rotate(0deg)");
                            }
                            $jq("#txtPostalCode").val(result.PostalCode);
                        },
                        function() {
                            var locateErrors = [
                                {
                                    Field: 'txtPostalCode',
                                    Text:
                                        'We were unable to locate you. Please make sure you have a data connection and try again.'
                                }
                            ];
                            if (!regMgrOptions.customLocatorIcon) {
                                window.clearInterval(animation);
                                $jq(locator).css("transform", "rotate(0deg)");
                            }
                            multiStepProcessPanelComplete(locateErrors);
                        });
                });

            _regMgr.searchPositionLocators.call(thisObj);
            $jq(window).on("resize", function() {
                _regMgr.searchPositionLocators.call(thisObj);
            });

            $jq(".btnnavback").on("click", $jq.proxy(multiStepShowPreviousPanel, thisObj));
            $jq(".btnnavterms").on("click", $jq.proxy(multiStepShowTerms, thisObj));
            $jq(".btnnavgender").on("click", $jq.proxy(multiStepShowGenderPanel, thisObj));

            $jq("#divRegGender").find(".btncontinue").on("click", $jq.proxy(multiStepProcessRegGenderPanel, thisObj));
            $jq("#divRegEmail").find(".btncontinue").on("click", $jq.proxy(multiStepProcessRegEmailPanel, thisObj));
            $jq("#divRegUsername").find(".btncontinue").on("click", $jq.proxy(multiStepProcessRegUsernamePanel, thisObj));

            var regMgr = _regMgr;
            _regMgr.OnRegistrationSuccess(
                function(sender, regData) {
                    multiStepClearErrors();
                    var facebookMember = PeopleMedia.CP.FacebookImportMember();
                    if (PeopleMedia.CP.FacebookImportAttempted() &&
                        !PeopleMedia.CP.FacebookImportFailed() &&
                        facebookMember) {
                        var greeting = facebookMember.AboutYou;
                        var photoUrl = facebookMember.PhotoUrl;
                        var apiContext = regData.Context;
                        var apiToken = regData.Token;
                        regMgr.setGreeting(apiContext,
                            apiToken,
                            greeting,
                            function(setGreetingError, setGreetingResult) {
                                regMgr.importPhoto(photoUrl,
                                    function(importPhotoResult) {
                                        multiStepRegistrationAuthenticateCompleted(sender, regData);
                                    });
                            });
                    } else {
                        multiStepRegistrationAuthenticateCompleted(sender, regData);
                    }
                });

            _regMgr.OnRegistrationFailure(
                function (sender, errors) {
                    var errorResult = convertErrorArrayToErrorObject(errors);
                    if (errorResult.duplicateEmail) {
                        errors = [
                            {
                                Field: null, // _regMgr.EmailAddressFieldname(),
                                Text: 'Sorry, an account has already been registered to that email address.' +
                                    '<div class="btnnavaltlogin"><a href="/v3/login">Login</a></div>' +
                                    '<div class="btnnavforgot"><a href="/v3/forgotpassword">Forgot Password?</a></div>',
                                IsHtml: true
                            }
                        ];
                        _regMgr.standardOnRegistrationFailure(sender, errors);
                    } else {
                        _regMgr.standardOnRegistrationFailure(sender, errors);
                    }
                    multiStepProcessPanelComplete(errors);
                });

            var $firstPanel = multiStepGetActivePanel();
            var firstPanelId = "divRegGender";
            if ($firstPanel.length > 0 && $firstPanel.attr("id")) {
                firstPanelId = $firstPanel.attr("id");
            }
            multiStepSetActivePanel(firstPanelId);
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "initializeSignupFlowTypeMultiStep" });
        }
    };

    // SIGNUP_FLOW_TYPE_MULTISTEP_WITH_SUGGEST (4)
    var initializeSignupFlowTypeMultiStepWithSuggest = function() {
        try {
            var thisObj = PeopleMedia.CP.LoginRegistration;
            var currentRegMgrOptions = _regMgrOptions;
            if (typeof currentRegMgrOptions !== "object" || currentRegMgrOptions === null) {
                currentRegMgrOptions({});
            }
            var regMgrOptions = { insertGender: true, combinedGender: true, loadOnly: true };
            if (typeof currentRegMgrOptions.questionOrder !== 'undefined') {
                regMgrOptions.questionOrder = currentRegMgrOptions.questionOrder;
            }
            if (typeof currentRegMgrOptions.questionDefaultValues !== 'undefined') {
                regMgrOptions.questionDefaultValues = currentRegMgrOptions.questionDefaultValues;
            }
            if (typeof currentRegMgrOptions.fieldValidate !== 'undefined') {
                regMgrOptions.fieldValidate = currentRegMgrOptions.fieldValidate;
            }
            if (typeof currentRegMgrOptions.fieldValidateImmediate !== 'undefined') {
                regMgrOptions.fieldValidateImmediate = currentRegMgrOptions.fieldValidateImmediate;
            }
            if (typeof currentRegMgrOptions.splitUsernamePassword !== 'undefined') {
                regMgrOptions.splitUsernamePassword = currentRegMgrOptions.splitUsernamePassword;
            }
            if (typeof currentRegMgrOptions.splitGenderSeeking !== 'undefined') {
                regMgrOptions.splitGenderSeeking = currentRegMgrOptions.splitGenderSeeking;
                regMgrOptions.combinedGender = false;
            }
            if (typeof currentRegMgrOptions.assignCountryCodeFromPostalCode !== 'undefined') {
                regMgrOptions.assignCountryCodeFromPostalCode = currentRegMgrOptions.assignCountryCodeFromPostalCode;
            }
            if (typeof currentRegMgrOptions.customLocatorIcon !== 'undefined') {
                regMgrOptions.customLocatorIcon = currentRegMgrOptions.customLocatorIcon;
            }
            regMgrOptions.cssOptions = initializeCssOptions((typeof currentRegMgrOptions.cssOptions !== 'undefined')
                ? currentRegMgrOptions.cssOptions
                : {});

            // use question ids from API for tracking
            $jq("body").attr("data-signupflow", signupFlowType());
            $jq("select[name='ddlGenderCombined']").attr("data-questionid", QUESTION_ID_GENDER_COMBINED);
            $jq("input[name='txtPostalCode']").attr("data-questionid", QUESTION_ID_POSTAL_CODE);
            $jq("input[name='txtEmailAddress']").attr("data-questionid", QUESTION_ID_EMAIL);
            $jq("input[name='txtBirthDate']").attr("data-questionid", QUESTION_ID_BIRTHDATE);
            $jq("input[name='txtUsername'],input[name='txtUsernameOther']").attr("data-questionid", QUESTION_ID_USERNAME);
            $jq("input[name='txtPassword']").attr("data-questionid", QUESTION_ID_PASSWORD);

            // searchPageInit
            if (!PeopleMedia.CP.GenderSeekEnabled()) {
                $jq("#ddlGenderCombined").find("option[value='11'], option[value='22']").remove();
            }
            if ((PeopleMedia.CP.DefaultGenderID() === 1 || PeopleMedia.CP.DefaultGenderID() === 2) &&
                (PeopleMedia.CP.DefaultGenderSeekID() === 1 || PeopleMedia.CP.DefaultGenderSeekID() === 2) &&
                (PeopleMedia.CP.GenderSeekEnabled() ||
                    PeopleMedia.CP.DefaultGenderID() !== PeopleMedia.CP.DefaultGenderSeekID())) {
                $jq('#ddlGenderCombined').val(PeopleMedia.CP.DefaultGenderID().toString() +
                    PeopleMedia.CP.DefaultGenderSeekID().toString());
            }

            // event handlers
            $jq(".locate, .locate-hidden, .locate-image").on("click",
                function(event) {
                    var locator = event.target;
                    if (!regMgrOptions.customLocatorIcon) {
                        var animation = window.setInterval(function() {
                                $jq(locator).animate({ rotate: "+=15deg" }, 0);
                            },
                            50);
                    }
                    _regMgr.locateMe(
                        function(result) {
                            if (!regMgrOptions.customLocatorIcon) {
                                window.clearInterval(animation);
                                $jq(locator).css("transform", "rotate(0deg)");
                            }
                            var $postalCode = $jq("#txtPostalCode");
                            $postalCode.val(result.PostalCode);
                            if (regMgrOptions.fieldValidate) {
                                $postalCode.addClass("inputon").trigger("change");
                            }
                        },
                        function() {
                            var locateErrors = [
                                {
                                    Field: 'txtPostalCode',
                                    Text:
                                        'We were unable to locate you. Please make sure you have a data connection and try again.'
                                }
                            ];
                            if (!regMgrOptions.customLocatorIcon) {
                                window.clearInterval(animation);
                                $jq(locator).css("transform", "rotate(0deg)");
                            }
                            multiStepProcessPanelComplete(locateErrors);
                        });
                });
            if (regMgrOptions.fieldValidateImmediate) {
                $jq("#txtPostalCode").on("keyup change",
                    $jq.proxy(multiStepValidatePostalCodeImmediate, thisObj));
                $jq("#txtEmailAddress").on("keyup change", $jq.proxy(multiStepValidateEmailImmediate, thisObj));
                $jq("#txtBirthDate").on("keyup change", $jq.proxy(multiStepValidateBirthdayImmediate, thisObj));
                $jq("#txtUsername").on("keyup change", $jq.proxy(multiStepValidateUsernameImmediate, thisObj));
                $jq("#txtPassword").on("keyup change", $jq.proxy(multiStepValidatePasswordImmediate, thisObj));
            }

            _regMgr.searchPositionLocators.call(thisObj);
            $jq(window).on("resize", function() {
                _regMgr.searchPositionLocators.call(thisObj);
            });

            var processRegGenderPanel;
            var processRegEmailPanel;
            var processRegUsernamePanel;
            if (regMgrOptions.fieldValidate) {
                processRegGenderPanel = multiStepFieldValidateProcessRegGenderPanel;
                processRegEmailPanel = multiStepFieldValidateProcessRegEmailPanel;
                processRegUsernamePanel = multiStepFieldValidateProcessRegUsernamePanel;
                $jq("#divRegistration")
                    .on("focus blur",
                        "input[type=text],input[type=password],input[type=email],input[type=date],select",
                        $jq.proxy(multiStepFieldValidateFocus, thisObj));
            } else {
                processRegGenderPanel = multiStepProcessRegGenderPanel;
                processRegEmailPanel = multiStepProcessRegEmailorFBPanel;
                processRegUsernamePanel = multiStepProcessRegUsernamePanel;
            }

            $jq(".btnnavback").on("click", $jq.proxy(multiStepShowPreviousPanel, thisObj));
            $jq(".btnnavterms").on("click", $jq.proxy(multiStepShowTerms, thisObj));
            $jq(".btnnavgender").on("click", $jq.proxy(multiStepShowGenderPanel, thisObj));

            $jq("#divRegGender").find(".btncontinue").on("click", $jq.proxy(processRegGenderPanel, thisObj));
            $jq("#divRegEmail").find(".btncontinue").on("click", $jq.proxy(processRegEmailPanel, thisObj));
            $jq("#divRegUsername").find(".btncontinue").on("click", $jq.proxy(processRegUsernamePanel, thisObj));

            var regMgr = _regMgr;
            _regMgr.OnRegistrationSuccess(
                function(sender, regData) {
                    multiStepClearErrors();
                    var facebookMember = PeopleMedia.CP.FacebookImportMember();
                    if (PeopleMedia.CP.FacebookImportAttempted() &&
                        !PeopleMedia.CP.FacebookImportFailed() &&
                        facebookMember) {
                        var greeting = facebookMember.AboutYou;
                        var photoUrl = facebookMember.PhotoUrl;
                        var apiContext = regData.Context;
                        var apiToken = regData.Token;
                        regMgr.setGreeting(apiContext,
                            apiToken,
                            greeting,
                            function(setGreetingError, setGreetingResult) {
                                regMgr.importPhoto(photoUrl,
                                    function(importPhotoResult) {
                                        multiStepRegistrationAuthenticateCompleted(sender, regData);
                                    });
                            });
                    } else {
                        multiStepRegistrationAuthenticateCompleted(sender, regData);
                    }
                });

            _regMgr.OnRegistrationFailure(
                function (sender, errors) {
                    multiStepClearErrors();
                    var errorResult = convertErrorArrayToErrorObject(errors);
                    if (errorResult.duplicateEmail) {
                        errors = [
                            {
                                Field: null, // _regMgr.EmailAddressFieldname(),
                                Text: 'Sorry, an account has already been registered to that email address.' +
                                    '<div class="btnnavaltlogin"><a href="/v3/login">Login</a></div>' +
                                    '<div class="btnnavforgot"><a href="/v3/forgotpassword">Forgot Password?</a></div>',
                                IsHtml: true
                            }
                        ];
                        _regMgr.standardOnRegistrationFailure(sender, errors);
                    } else {
                        _regMgr.standardOnRegistrationFailure(sender, errors);
                    }
                    multiStepProcessPanelComplete(errors);
                });

            var $firstPanel = multiStepGetActivePanel();
            var firstPanelId = "divRegGender";
            if ($firstPanel.length > 0 && $firstPanel.attr("id")) {
                firstPanelId = $firstPanel.attr("id");
            }
            multiStepSetActivePanel(firstPanelId);
            //if (regMgrOptions.fieldValidate) {
            //    // pre-validate the gender drop-down since gender values are correct
            //    var genderFieldId = (regMgr.HasGenderCombinedField()) ? regMgr.GenderCombinedFieldname() : regMgr.GenderFieldname();
            //    var validate = multiStepFieldValidateGetValidateFunction(genderFieldId);
            //    if (validate && typeof (validate) === "function") {
            //        validate.call(this, function($genderTarget, genderErrors) {
            //            multiStepFieldValidateSetErrorState($genderTarget, genderErrors);
            //        });
            //    }
            //}
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "initializeSignupFlowTypeMultiStep" });
        }
    };

    var getDisplayedQuestionIds = function($container) {
        var result = [];
        try {
            if (typeof ($container) === 'undefined' || $container === null || $container.length === 0) {
                return result;
            }
            $container.find("[data-questionid]").each(function () {
                var $elem = $jq(this);
                // var elemTag = $elem.get(0).tagName.toLowerCase();
                // var elemType = $elem.attr("type");
                var id = $elem.attr("data-questionid");
                if (!PeopleMedia.CP.Utilities.isNullOrEmpty(id)) {
                    var idNum = parseInt(id, 10);
                    // only return unique values
                    if (!isNaN(idNum) && result.indexOf(idNum) === -1) {
                        result.push(idNum);
                    }
                }
            });
            return result;
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "getDisplayedQuestionIds" });
            return result;
        }
    };

    var multiStepRegistrationAuthenticateCompleted = function(sender, regData) {
        try {
            if (profilePage() !== null) {
                if (PeopleMedia.CP.gotoLpsPage) {
                    PeopleMedia.CP.gotoLpsPage(profilePage());
                } else {
                    PeopleMedia.CP.gotoSite("/v3/lps?cpp=" + profilePage());
                }
            } else {
                _regMgr.standardOnRegistrationSuccess(sender, regData);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepRegistrationAuthenticateCompleted" });
        }
    };

    var multiStepGetActivePanel = function() {
        try {
            return $jq(".panel").filter(".activePanel");
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepGetActivePanel" });
        }
        return {};
    };

    var multiStepGetPrevPanelId = function($activePanel) {
        var prevPanelId = "";
        try {
            $activePanel = $activePanel || multiStepGetActivePanel();
            if ($activePanel && $activePanel.length > 0) {
                prevPanelId = $activePanel.attr("data-prevpanel");
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepGetPrevPanelId" });
        }
        return prevPanelId;
    };

    var multiStepGetNextPanelId = function($activePanel) {
        var nextPanelId = "";
        try {
            $activePanel = $activePanel || multiStepGetActivePanel();
            if ($activePanel && $activePanel.length > 0) {
                nextPanelId = $activePanel.attr("data-nextpanel");
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepGetNextPanelId" });
        }
        return nextPanelId;
    };

    var multiStepSetActivePanel = function(activePanelId) {
        var panelExists = false;
        try {
            var prevPanelId;
            var $prevPanel;
            var activePanelSelector = "#" + activePanelId;
            var $activePanel = $jq(activePanelSelector);
            if ($activePanel.length > 0) {
                panelExists = true;
                var cssOptions = _cssOptions;

                if (cssOptions.panelShow || cssOptions.panelHide) {
                    // don't use jQuery hide() and show() methods on .panel
                    $jq(".panel").removeClass("activePanel").removeClass(cssOptions.panelShow)
                        .addClass(cssOptions.panelHide);
                    $activePanel.addClass("activePanel").removeClass(cssOptions.panelHide)
                        .addClass(cssOptions.panelShow);
                } else {
                    $jq(".panel").removeClass("activePanel").hide();
                    $activePanel.addClass("activePanel").show();
                }

                prevPanelId = multiStepGetPrevPanelId($activePanel);
                if (prevPanelId) {
                    $prevPanel = $jq("#" + prevPanelId);
                }

                if (cssOptions.navBackShow || cssOptions.navBackHide) {
                    // don't use jQuery hide() and show() methods on .btnnavback
                    if ($prevPanel && $prevPanel.length > 0) {
                        $jq(".btnnavback").removeClass(cssOptions.navBackHide).addClass(cssOptions.navBackShow);
                    } else {
                        $jq(".btnnavback").removeClass(cssOptions.navBackShow).addClass(cssOptions.navBackHide);
                    }
                } else {
                    if ($prevPanel && $prevPanel.length > 0) {
                        $jq(".btnnavback").show();
                    } else {
                        $jq(".btnnavback").hide();
                    }
                }

                $jq("html,body").scrollTop(0);
                multiStepSetActivePanelFocus();

                PeopleMedia.CP.trackRegistrationEventShow(activePanelSelector, "multiStepSetActivePanel");

                var displayedQuestions = getDisplayedQuestionIds($activePanel);
                if (displayedQuestions.length > 0) {
                    PeopleMedia.CP.trackRegistrationEventShowRegQuestions(displayedQuestions);
                }

                fireOnPanelDisplay({ panelId: activePanelId, prevPanelId: prevPanelId });
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepSetActivePanel" });
        }
        return panelExists;
    };

    var multiStepSetActivePanelFocus = function() {
        try {
            var errorField;
            var errorFieldAlt;
            var $focusField = null;
            var $activePanel = multiStepGetActivePanel();
            if ($activePanel.length > 0) {
                var $firstError = $activePanel.find(".errorMsg:visible").first();
                if ($firstError.length > 0) {
                    errorField = $firstError.attr("data-field");
                    if (errorField) {
                        $focusField = $activePanel.find("#" + errorField + ":visible:enabled");
                        if ($focusField.length === 0) {
                            errorFieldAlt = $firstError.attr("data-fieldalt");
                            if (errorFieldAlt) {
                                $focusField = $activePanel.find("#" + errorFieldAlt + ":visible:enabled");
                            }
                        }
                    }
                }
                if ($focusField === null || $focusField.length === 0) {
                    $focusField = $activePanel.find("input,textarea,select:visible:enabled").first();
                    //if (regMgrOptions().fieldValidate && $firstError.length === 0) {
                    //    $focusField = [];
                    //}
                }
                if ($focusField && $focusField.length > 0) {
                    $focusField.trigger("focus");
                }
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepSetActivePanelFocus" });
        }
    };

    var multiStepShowNextPanel = function(e) {
        try {
            preventEventDefaultBehavior(e);
            var nextPanelId = multiStepGetNextPanelId();
            if (nextPanelId) {
                multiStepSetActivePanel(nextPanelId);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepShowNextPanel" });
        }
    };

    var multiStepShowPreviousPanel = function(e) {
        try {
            preventEventDefaultBehavior(e);
            var prevPanelId = multiStepGetPrevPanelId();
            if (prevPanelId) {
                multiStepSetActivePanel(prevPanelId);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepShowPreviousPanel" });
        }
    };

    var multiStepShowGenderPanel = function(e) {
        try {
            preventEventDefaultBehavior(e);
            return multiStepSetActivePanel("divRegGender");
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepShowGenderPanel" });
            return false;
        }
    };

    var multiStepShowTerms = function(event) {
        try {
            preventEventDefaultBehavior(event);
            var $target = $jq(event.target);
            var $linkPanel;
            var prevId = "";
            // set divTerm "data-prevpanel" attribute to id of panel the user clicked on so "back to" link will work.
            if ($target.length > 0) {
                $linkPanel = $target.closest(".panel");
                if ($linkPanel.length > 0) {
                    prevId = $linkPanel.attr("id");
                    if (prevId) {
                        var $termPanel = $jq("#divTerms");
                        $termPanel.attr("data-prevpanel", prevId);
                    }
                }
            }
            multiStepSetActivePanel("divTerms");
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "divTerms" });
        }
    };

    var multiStepSetCountryCodeFromPostalCode = function() {
        try {
            var hasAlpha = /[A-Za-z]/;
            var $countryField = $jq("#ddlCountry");
            if ($countryField.length > 0 && $countryField.attr("type") === "hidden") {
                var $postalCodeField = $jq("#txtPostalCode");
                if ($postalCodeField.length > 0) {
                    var postalCode = ($postalCodeField.val() || "").trim();
                    if (hasAlpha.test(postalCode)) {
                        $countryField.val('CA');
                    } else {
                        $countryField.val('US');
                    }
                }
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepSetCountryCodeFromPostalCode" });
        }
    };

    var multiStepProcessPanelComplete = function(panelErrors) {
        try {
            if (panelErrors && panelErrors.length > 0) {
                multiStepShowErrors(panelErrors);
                multiStepTrackErrors(panelErrors);
            } else {
                multiStepClearErrors();
                multiStepShowNextPanel();
            }
            _panelValidateInProcess = false;
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepProcessPanelComplete" });
            _panelValidateInProcess = false;
        }
    };

    var multiStepClearErrorMsg = function ($elements) {
        var cssOptions = _cssOptions;
        if (cssOptions.errorMsgShow || cssOptions.errorMsgHide) {
            // don't use .hide()
            $elements.html("").removeClass(cssOptions.errorMsgShow).addClass(cssOptions.errorMsgHide);
        } else {
            $elements.html("").hide();
        }
    };

    var multiStepClearErrorSummary = function ($elements) {
        var cssOptions = _cssOptions;
        if (cssOptions.errorSummaryShow || cssOptions.errorSummaryHide) {
            // don't use .hide()
            $elements.html("").removeClass(cssOptions.errorSummaryShow).addClass(cssOptions.errorSummaryHide);
        } else {
            $elements.html("").hide();
        }
    };

    var multiStepShowFieldErrorMsg = function ($element, errorText, useHtml) {
        var cssOptions = _cssOptions;
        if (useHtml) {
            $element.html(errorText).attr("data-html", true);
        } else {
            $element.text(errorText).attr("data-html", false);
        }
        if (cssOptions.errorMsgShow || cssOptions.errorMsgHide) {
            // don't use .show()
            $element.removeClass(cssOptions.errorMsgHide).addClass(cssOptions.errorMsgShow);
            $jq(window).scrollTop(0);
        } else {
            $element.show();
            $jq(window).scrollTop(0);
        }
    };

    var multiStepShowSummaryErrorMsg = function($element, errorText, useHtml) {
        var cssOptions = _cssOptions;
        if (useHtml) {
            $element.html(errorText).attr("data-html", true);
        } else {
            $element.text(errorText).attr("data-html", false);
        }
        if (cssOptions.errorSummaryShow || cssOptions.errorSummaryHide) {
            // don't use .show()
            $element.removeClass(cssOptions.errorSummaryHide).addClass(cssOptions.errorSummaryShow);
        } else {
            $element.show();
        }
    };

    var multiStepClearErrors = function(errors) {
        try {
            multiStepClearErrorMsg($jq(".errorMsg"));
            multiStepClearErrorSummary($jq(".errorSummary"));
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepClearErrors" });
        }
    };

    var multiStepTrackErrors = function(errors) {
        try {
            var messageTracking = [];
            var $activePanel = multiStepGetActivePanel();

            if ($activePanel.length > 0) {
                var $errorSummary = $activePanel.find(".errorSummary");

                if ($errorSummary.filter(":visible").length > 0) {
                    var errorText;
                    if ($errorSummary.attr("data-html") === "true") {
                        errorText = $errorSummary.html();
                    } else {
                        errorText = $errorSummary.text();
                    }
                    if (errorText) {
                        messageTracking.push(errorText);
                    }
                }

                var $errorMsg = $activePanel.find(".errorMsg,.errorMsg2");
                $errorMsg.each(function () {
                    var $item = $jq(this);
                    if ($item.filter(":visible").length > 0) {
                        var errorText;
                        if ($item.attr("data-html") === "true") {
                            errorText = $item.html();
                        } else {
                            errorText = $item.text();
                        }
                        if (errorText) {
                            messageTracking.push(errorText);
                        }
                    }
                });
            }

            if (messageTracking.length > 0) {
                PeopleMedia.CP.trackRegistrationEventShowRegErrors(messageTracking);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepTrackErrors" });
        }
    };

    var multiStepShowErrors = function(errors) {
        try {
            var $errorMsg = $jq(".errorMsg");
            var $activePanel = multiStepGetActivePanel();
            var $errorSummary = $activePanel.find(".errorSummary");

            multiStepClearErrorMsg($errorMsg);
            multiStepClearErrorSummary($errorSummary);

            var $currentErrorField;
            var $firstPanel = null;
            var found = false;
            var dataField;
            var dataFieldAlt;
            for (var i = 0; i < errors.length; i++) {
                found = false;
                if (errors[i]) {
                    var useHtml = (errors[i].IsHtml === true);
                    if (errors[i].Field && errors[i].Text) {
                        for (var j = 0; j < $errorMsg.length; j++) {
                            $currentErrorField = $jq($errorMsg[j]);
                            dataField = $currentErrorField.attr("data-field");
                            dataFieldAlt = $currentErrorField.attr("data-fieldalt");
                            if (errors[i].Field === dataField || errors[i].Field === dataFieldAlt) {
                                found = true;
                                
                                multiStepShowFieldErrorMsg($currentErrorField, errors[i].Text, useHtml);
                                if (!$firstPanel && !errors[i].SkipPanelUpdateToClosestError) {
                                    $firstPanel = $currentErrorField.closest(".panel");
                                }
                                //break; <- REMOVED so that multiple errors tied to the same box get rendered.
                            }
                        }
                        if (!found) {
                            multiStepShowSummaryErrorMsg($errorSummary, errors[i].Text, useHtml);
                        }
                    } else if (errors[i].Text) {
                        multiStepShowSummaryErrorMsg($errorSummary, errors[i].Text, useHtml);
                    } else if ($jq.type(errors[i]) === "string") {
                        multiStepShowSummaryErrorMsg($errorSummary, errors[i], useHtml);
                    }
                }
            }

            if ($firstPanel && $firstPanel.length > 0 && $firstPanel.attr("id") !== $activePanel.attr("id")) {
                multiStepSetActivePanel($firstPanel.attr("id"));
            } else {
                multiStepSetActivePanelFocus();
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepShowErrors" });
        }
    };

    var multiStepProcessRegGenderPanel = function(e) {
        try {
            preventEventDefaultBehavior(e);
            _panelValidateInProcess = true;
            multiStepSetCountryCodeFromPostalCode();
            var panelErrors = [];
            var genderError = PeopleMedia.CP.getFirstError(_regMgr.validateGender());
            if (genderError) {
                panelErrors.push(genderError);
            }

            _regMgr.validatePostalCode(function(errors) {
                var postalError = PeopleMedia.CP.getFirstError(errors);
                if (postalError) {
                    panelErrors.push(postalError);
                } else {
                    _regMgr.setBackgroundCheckDisclaimer(function () {
                        multiStepProcessPanelComplete(panelErrors);
                    });
                    return;
                }
                multiStepProcessPanelComplete(panelErrors);
            });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepProcessRegGenderPanel" });
            _panelValidateInProcess = false;
        }
    };

    var multiStepProcessRegEmailPanel = function(e) {
        try {
            preventEventDefaultBehavior(e);
            _panelValidateInProcess = true;
            var panelErrors = [];
            _regMgr.registerMarketingCapture();

            var emailError = PeopleMedia.CP.getFirstError(_regMgr.validateEmailAddress());
            if (emailError) {
                panelErrors.push(emailError);
            }

            var birthdateError = PeopleMedia.CP.getFirstError(_regMgr.validateBirthDay());
            if (birthdateError) {
                panelErrors.push(birthdateError);
            }

            if (!emailError) {
                _regMgr.checkEmailAvailability(
                    function() {
                        multiStepProcessPanelComplete(panelErrors);
                    },
                    function(errors, data) {
                        var emailAvailableError = PeopleMedia.CP.getFirstError(errors);
                        if (emailAvailableError) {
                            panelErrors.push(emailAvailableError);
                        }
                        multiStepProcessPanelComplete(panelErrors);
                    });
            } else {
                multiStepProcessPanelComplete(panelErrors);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepProcessRegEmailPanel" });
            _panelValidateInProcess = false;
        }
    };

    var multiStepProcessRegEmailorFBPanel = function(e) {
        try {
            preventEventDefaultBehavior(e);
            _panelValidateInProcess = true;
            var panelErrors = [];
            _regMgr.registerMarketingCapture();

            var emailError = PeopleMedia.CP.getFirstError(_regMgr.validateEmailAddress());
            if (emailError) {
                panelErrors.push(emailError);
            }

            if (!emailError) {
                _regMgr.checkEmailAvailability(
                    function() {
                        multiStepProcessPanelComplete(panelErrors);
                    },
                    function(errors, data) {
                        var emailAvailableError = PeopleMedia.CP.getFirstError(errors);
                        if (emailAvailableError) {
                            panelErrors.push(emailAvailableError);
                        }
                        multiStepProcessPanelComplete(panelErrors);
                    });
            } else {
                multiStepProcessPanelComplete(panelErrors);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepProcessRegEmailorFBPanel" });
            _panelValidateInProcess = false;
        }
    };

    var multiStepProcessRegUsernamePanel = function(e) {
        try {
            preventEventDefaultBehavior(e);
            _panelValidateInProcess = true;
            var panelErrors = [];

            var usernameError = PeopleMedia.CP.getFirstError(_regMgr.validateUsername());
            if (usernameError) {
                panelErrors.push(usernameError);
            }

            var passwordError = PeopleMedia.CP.getFirstError(_regMgr.validatePassword());
            if (passwordError) {
                panelErrors.push(passwordError);
            }

            if (panelErrors.length === 0) {
                _regMgr.processRegistration();
            } else {
                multiStepProcessPanelComplete(panelErrors);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepProcessRegUsernamePanel" });
            _panelValidateInProcess = false;
        }
    };

    var multiStepFieldValidateFocus = function(event) {
        try {
            var $target = $jq(event.target);
            if ($target.length > 0) {
                if (event.type === "focus" || event.type === "focusin") {
                    multiStepFieldValidateHighlight($target);
                } else if (event.type === "blur" || event.type === "focusout") {
                    multiStepFieldValidateRemoveHighlight($target);
                }
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepFieldValidateFocus" });
        }
    };

    var multiStepFieldValidateHighlight = function($target) {
        try {
            $target.addClass("inputon focuscolor");

            // special handling for focus on birthdate to hide placeholder text
            var elementId = $target.attr("id");

            var birthDateFieldId = (_regMgr.HasBirthDateCombinedField())
                ? _regMgr.BirthDateCombinedFieldname()
                : _regMgr.BirthYearFieldname();
            if (elementId === birthDateFieldId) {
                $jq("#hidebirthday").hide();
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepFieldValidateHighlight" });
        }
    };

    var multiStepFieldValidateRemoveHighlight = function($target) {
        try {
            $target.removeClass("focuscolor");
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepFieldValidateRemoveHighlight" });
        }
    };

    var multiStepFieldValidateSetErrorState = function($target, errors) {
        try {
            var errorsIsArray = (Array.isArray)
                ? Array.isArray(errors)
                : Object.prototype.toString.call(errors) === '[object Array]';
            var hasError = (errorsIsArray) ? (errors.length > 0) : (!!errors);
            if (hasError) {
                $target.removeClass("addgreencheck").addClass("addredx");
            } else {
                $target.removeClass("addredx").addClass("addgreencheck");
            }
            // var $panel = $target.closest(".panel");
            // var panelValid = multiStepFieldValidateIsPanelValid($panel);
            // multiStepFieldValidateUpdateButtonState($panel, panelValid);
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepFieldValidateSetErrorState" });
        }
    };

    var multiStepFieldValidateProcessRegGenderPanel = function(e) {
        try {
            preventEventDefaultBehavior(e);
            _panelValidateInProcess = true;
            var panelErrors = [];
            // var $panel = multiStepGetActivePanel();
            // force button to be enabled as soon as form is submitted so we don't see a gray button while waiting for a callback
            // multiStepFieldValidateUpdateButtonState($panel, true);

            multiStepSetCountryCodeFromPostalCode();
            multiStepFieldValidateGender(function($genderTarget, genderErrors) {
                panelErrors = panelErrors.concat(genderErrors);
                multiStepFieldValidateSetErrorState($genderTarget, genderErrors);
                multiStepFieldValidatePostalCode(function ($postalTarget, postalErrors) {
                    panelErrors = panelErrors.concat(postalErrors);
                    multiStepFieldValidateSetErrorState($postalTarget, postalErrors);
                    multiStepShowErrors(panelErrors);

                    multiStepProcessPanelComplete(panelErrors);
                });
            });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepFieldValidateProcessRegGenderPanel" }); 
            _panelValidateInProcess = false;
        }
    };

    var multiStepFieldValidateProcessRegEmailPanel = function(e) {
        try {
            preventEventDefaultBehavior(e);
            _panelValidateInProcess = true;
            var panelErrors = [];
            // var $panel = multiStepGetActivePanel();
            // force button to be enabled as soon as form is submitted so we don't see a gray button while waiting for a callback
            // multiStepFieldValidateUpdateButtonState($panel, true);

            multiStepFieldValidateEmailAddress(function($emailTarget, emailErrors) {
                panelErrors = panelErrors.concat(emailErrors);
                multiStepFieldValidateSetErrorState($emailTarget, emailErrors);
                multiStepFieldValidateBirthDay(function($birthdayTarget, birthdayErrors) {
                    panelErrors = panelErrors.concat(birthdayErrors);
                    multiStepFieldValidateSetErrorState($birthdayTarget, birthdayErrors);
                    multiStepShowErrors(panelErrors);

                    multiStepProcessPanelComplete(panelErrors);
                });
            });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepFieldValidateProcessRegEmailPanel" });
            _panelValidateInProcess = false;
        }
    };

    var multiStepFieldValidateProcessRegUsernamePanel = function(e) {
        try {
            preventEventDefaultBehavior(e);
            _panelValidateInProcess = true;
            var panelErrors = [];
            // var $panel = multiStepGetActivePanel();
            // force button to be enabled as soon as form is submitted so we don't see a gray button while waiting for a callback
            // multiStepFieldValidateUpdateButtonState($panel, true);

            multiStepFieldValidateUsername(function($usernameTarget, usernameErrors) {
                panelErrors = panelErrors.concat(usernameErrors);
                multiStepFieldValidateSetErrorState($usernameTarget, usernameErrors);
                multiStepFieldValidatePassword(function($passwordTarget, passwordErrors) {
                    panelErrors = panelErrors.concat(passwordErrors);
                    multiStepFieldValidateSetErrorState($passwordTarget, passwordErrors);
                    multiStepShowErrors(panelErrors);

                    // after validations
                    if (panelErrors.length === 0) {
                        _regMgr.processRegistration();
                    } else {
                        multiStepProcessPanelComplete(panelErrors);
                    }
                });
            });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepFieldValidateProcessRegUsernamePanel" });
            _panelValidateInProcess = false;
        }
    };

    var multiStepFieldValidateGender = function(onComplete) {
        var thisObj = PeopleMedia.CP.LoginRegistration;
        var $target;
        try {
            var genderFieldId = (_regMgr.HasGenderCombinedField())
                ? _regMgr.GenderCombinedFieldname()
                : _regMgr.GenderFieldname();
            $target = $jq("#" + genderFieldId);
            var errors = _regMgr.validateGender();
            if (onComplete) {
                onComplete.call(thisObj, $target, errors);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepFieldValidateGender" });
            if (onComplete) {
                onComplete.call(thisObj, $target, []);
            }
        }
    };

    var multiStepFieldValidatePostalCode = function(onComplete) {
        var thisObj = PeopleMedia.CP.LoginRegistration;
        var $target;
        try {
            $target = $jq("#" + _regMgr.PostalCodeFieldname());

            multiStepSetCountryCodeFromPostalCode();
            _regMgr.validatePostalCode(function (validateErrors) {
                if (validateErrors && validateErrors.length === 0) {
                    _regMgr.setBackgroundCheckDisclaimer(function () {
                        if (onComplete) {
                            onComplete.call(thisObj, $target, validateErrors);
                        }
                    });
                    return;
                }
                if (onComplete) {
                    onComplete.call(thisObj, $target, validateErrors);
                }
            });
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepFieldValidatePostalCode" });
            if (onComplete) {
                onComplete.call(thisObj, $target, []);
            }
        }
    };

    var multiStepFieldValidateEmailAddress = function(onComplete) {
        var thisObj = PeopleMedia.CP.LoginRegistration;
        var $target;
        try {
            $target = $jq("#" + _regMgr.EmailAddressFieldname());
            _regMgr.registerMarketingCapture();
            var emailErrors = _regMgr.validateEmailAddress();

            if (emailErrors.length === 0) {
                _regMgr.checkEmailAvailability(
                    function() {
                        if (onComplete) {
                            onComplete.call(thisObj, $target, emailErrors);
                        }
                    },
                    function(errors, data) {
                        if (onComplete) {
                            onComplete.call(thisObj, $target, errors);
                        }
                    });
            } else {
                if (onComplete) {
                    onComplete.call(thisObj, $target, emailErrors);
                }
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepFieldValidateEmailAddress" });
            if (onComplete) {
                onComplete.call(thisObj, $target, []);
            }
        }
    };

    var multiStepFieldValidateBirthDay = function(onComplete) {
        var thisObj = PeopleMedia.CP.LoginRegistration;
        var $target;
        try {
            var birthDateFieldId = (_regMgr.HasBirthDateCombinedField())
                ? _regMgr.BirthDateCombinedFieldname()
                : _regMgr.BirthYearFieldname();
            $jq("#hidebirthday").hide();
            $target = $jq("#" + birthDateFieldId);
            var errors = _regMgr.validateBirthDay();
            if (onComplete) {
                onComplete.call(thisObj, $target, errors);
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepFieldValidateBirthDay" });
            if (onComplete) {
                onComplete.call(thisObj, $target, []);
            }
        }
    };

    var multiStepFieldValidateUsername = function(onComplete) {
        var thisObj = PeopleMedia.CP.LoginRegistration;
        var $target;
        try {
            $target = $jq("#" + _regMgr.UsernameFieldname());
            var usernameErrors = _regMgr.validateUsername();
            if (usernameErrors.length === 0) {
                _regMgr.validateUsernameFormat(
                    function(errors, data) {
                        if (onComplete) {
                            onComplete.call(thisObj, $target, errors);
                        }
                    });
            } else {
                if (onComplete) {
                    onComplete.call(thisObj, $target, usernameErrors);
                }
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepFieldValidateUsername" });
            if (onComplete) {
                onComplete.call(thisObj, $target, []);
            }
        }
    };

    var multiStepFieldValidatePassword = function(onComplete) {
        var thisObj = PeopleMedia.CP.LoginRegistration;
        var $target;
        try {
            $target = $jq("#" + _regMgr.PasswordFieldname());
            var passwordErrors = _regMgr.validatePassword();
            if (passwordErrors.length === 0) {
                _regMgr.validatePasswordFormat(
                    function(errors, data) {
                        if (onComplete) {
                            onComplete.call(thisObj, $target, errors);
                        }
                    });
            } else {
                if (onComplete) {
                    onComplete.call(thisObj, $target, passwordErrors);
                }
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepFieldValidatePassword" });
            if (onComplete) {
                onComplete.call(thisObj, $target, []);
            }
        }
    };

    var multiStepValidatePostalCodeImmediate = function(event) {
        try {
            var $postalCode = $jq(event.target);
            var postalCodeId = $postalCode.attr("id");
            var postalFilter = "[data-field='" + postalCodeId + "']";
            var value = $postalCode.val();
            var $check = $jq(".checked").filter(postalFilter);
            var $errorMsg = $jq(".errorMsg").filter(postalFilter);
            if (_regMgr.validatePostalCodeFormatIsUsa(value) ||
                _regMgr.validatePostalCodeFormatIsCanada(value)) {
                $postalCode.removeClass("invalidZip addredx").addClass("validZip addgreencheck");
                $check.removeClass("hidden invalidcheck").addClass("validcheck");
                $errorMsg.addClass("hidden");
            } else {
                $postalCode.removeClass("validZip addgreencheck").addClass("invalidZip addredx");
                $check.removeClass("hidden validcheck").addClass("invalidcheck");
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepValidatePostalCodeImmediate" });
        }
    };

    var multiStepValidateEmailImmediate = function(event) {
        try {
            var $email = $jq(event.target);
            var emailId = $email.attr("id");
            var emailFilter = "[data-field='" + emailId + "']";
            var value = $email.val();
            var $check = $jq(".checked").filter(emailFilter);
            var $errorMsg = $jq(".errorMsg").filter(emailFilter);
            if (_regMgr.validateEmailAddressFormat(value)) {
                $email.removeClass("invalidEmail addredx").addClass("validEmail addgreencheck");
                $check.removeClass("hidden invalidcheck").addClass("validcheck");
                $errorMsg.addClass("hidden");
            } else {
                $email.removeClass("validEmail addgreencheck").addClass("invalidEmail addredx");
                $check.removeClass("hidden validcheck").addClass("invalidcheck");
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepValidateEmailImmediate" });
        }
    };

    var multiStepValidateBirthdayImmediate = function(event) {
        try {
            var $birthday = $jq(event.target);
            var birthdayId = $birthday.attr("id");
            var birthdayFilter = "[data-field='" + birthdayId + "']";
            var value = $birthday.val();
            var $check = $jq(".checked").filter(birthdayFilter);
            var $errorMsg = $jq(".errorMsg").filter(birthdayFilter);
            var validateResult = (_regMgr.validateBirthDayFormat(value));
            if (validateResult && validateResult.isValid) {
                $birthday.removeClass("invalidBirthday addredx").addClass("validBirthday addgreencheck");
                $check.removeClass("hidden invalidcheck").addClass("validcheck");
                $errorMsg.addClass("hidden");
            } else {
                $birthday.removeClass("validBirthday addgreencheck").addClass("invalidBirthday addredx");
                $check.removeClass("hidden validcheck").addClass("invalidcheck");
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepValidateBirthdayImmediate" });
        }
    };

    var multiStepValidateUsernameImmediate = function(event) {
        try {
            var $username = $jq(event.target);
            var usernameId = $username.attr("id");
            var usernameFilter = "[data-field='" + usernameId + "']";
            var value = $username.val();
            var $check = $jq(".checked").filter(usernameFilter);
            var $errorMsg = $jq(".errorMsg").filter(usernameFilter);
            if (_regMgr.validateUsernameFormatSimple(value)) {
                $username.removeClass("invalidUsername addredx").addClass("validUsername addgreencheck");
                $check.removeClass("hidden invalidcheck").addClass("validcheck");
                $errorMsg.addClass("hidden");
            } else {
                $username.removeClass("validUsername addgreencheck").addClass("invalidUsername addredx");
                $check.removeClass("hidden validcheck").addClass("invalidcheck");
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepValidateUsernameImmediate" });
        }
    };

    var multiStepValidatePasswordImmediate = function(event) {
        try {
            var $password = $jq(event.target);
            var passwordId = $password.attr("id");
            var passwordFilter = "[data-field='" + passwordId + "']";
            var value = $password.val();
            var $check = $jq(".checked").filter(passwordFilter);
            var $errorMsg = $jq(".errorMsg").filter(passwordFilter);
            if (_regMgr.validatePasswordFormatSimple(value)) {
                $password.removeClass("invalidPassword addredx").addClass("validPassword addgreencheck");
                $check.removeClass("hidden invalidcheck").addClass("validcheck");
                $errorMsg.addClass("hidden");
            } else {
                $password.removeClass("validPassword addgreencheck").addClass("invalidPassword addredx");
                $check.removeClass("hidden validcheck").addClass("invalidcheck");
            }
        } catch (ex) {
            PeopleMedia.CP.handleException(ex, { oid: Oid, method: "multiStepValidatePasswordImmediate" });
        }
    };

    return {
        regMgr: regMgr,
        profileMgr: profileMgr,
        onSuccess: onSuccess,
        onQuestionDisplay: onQuestionDisplay,
        onPanelDisplay: onPanelDisplay,
        onFacebookImport: onFacebookImport,
        onReady: onReady,
        profilePage: profilePage,
        defaultProfileOptionListType: defaultProfileOptionListType,
        skipInitialGenderQuestion: skipInitialGenderQuestion,
        regMgrOptions: regMgrOptions,
        initialize: initialize,
        showNextPanel: showNextPanel,
        showPreviousPanel: showPreviousPanel,
        showZipPostalCodeCityStatePanel: showZipPostalCodeCityStatePanel,
        percentComplete: percentComplete,
        getDisplayedQuestionIds: getDisplayedQuestionIds,
        multiStepSetActivePanel: multiStepSetActivePanel
    };
})(jQuery);

// for backwards compatibility only
PeopleMedia.CP.LoginRegistrationManager = function () {
    "use strict";
    this.SIGNUP_FLOW_TYPE_REGISTRATION_FIRST = 0;
    this.SIGNUP_FLOW_TYPE_SINGLE_PROFILE_QUESTIONS_FIRST = 1;
    this.SIGNUP_FLOW_TYPE_SINGLE_QUESTIONS_REGISTRATION_FIRST = 2;
    this.SIGNUP_FLOW_TYPE_MULTISTEP = 3;
    this.SIGNUP_FLOW_TYPE_MULTISTEP_WITH_SUGGEST = 4;
    this.SIGNUP_FLOW_TYPE_MULTISTEP_FB_WITH_SUGGEST = 5;
};

// for backwards compatibility only
PeopleMedia.CP.LoginRegistrationManager.prototype = {
    regMgr: PeopleMedia.CP.LoginRegistration.regMgr,
    profileMgr: PeopleMedia.CP.LoginRegistration.profileMgr,
    onSuccess: PeopleMedia.CP.LoginRegistration.onSuccess,
    onQuestionDisplay: PeopleMedia.CP.LoginRegistration.onQuestionDisplay,
    onPanelDisplay: PeopleMedia.CP.LoginRegistration.onPanelDisplay,
    onFacebookImport: PeopleMedia.CP.LoginRegistration.onFacebookImport,
    onReady: PeopleMedia.CP.LoginRegistration.onReady,
    profilePage: PeopleMedia.CP.LoginRegistration.profilePage,
    defaultProfileOptionListType: PeopleMedia.CP.LoginRegistration.defaultProfileOptionListType,
    skipInitialGenderQuestion: PeopleMedia.CP.LoginRegistration.skipInitialGenderQuestion,
    regMgrOptions: PeopleMedia.CP.LoginRegistration.regMgrOptions,
    initialize: PeopleMedia.CP.LoginRegistration.initialize,
    showNextPanel: PeopleMedia.CP.LoginRegistration.showNextPanel,
    showPreviousPanel: PeopleMedia.CP.LoginRegistration.showPreviousPanel,
    showZipPostalCodeCityStatePanel: PeopleMedia.CP.LoginRegistration.showZipPostalCodeCityStatePanel,
    percentComplete: PeopleMedia.CP.LoginRegistration.percentComplete,
    getDisplayedQuestionIds: PeopleMedia.CP.LoginRegistration.getDisplayedQuestionIds,
    multiStepSetActivePanel: PeopleMedia.CP.LoginRegistration.multiStepSetActivePanel
};
